/* eslint-disable no-param-reassign */
import datepicker from 'js-datepicker';
import stringToBool from '../../_global/js/stringToBool';

/**
 * This class fix Matrix form imperfections.
 * Add missing attributes to input fields (autocomplete and placeholder)
 * Handles inline input clear button.
 *
 * @private
 */
export default function _searchForm() {
    /**
     * Main component selector.
     * @const {string}
     */
    const SEARCH_FORM_COMPONENT = '[data-component="search-form"]';

    // /**
    //  * Search input field selector.
    //  * @const {string}
    //  */
    // const SEARCH_INPUT_SELECTOR = '.sq-form-field:first-child';

    // /**
    //  * Clear action button selector.
    //  * @const {string}
    //  */
    // const SEARCH_CLEAR_ACTION_SELECTOR = '[data-click="clear-search"]';

    // /**
    //  * Class flag indicating if input has value.
    //  * @const {string}
    //  */
    // const SEARCH_HAS_INPUT_CLASS = 'search-form--has-input';

    // /**
    //  * Search placeholder text.
    //  * @const {string}
    //  */
    // const PLACEHOLDER_TEXT = 'Search this website';

    // /**
    //  * Since the form is not wrapped inside our component, we use submit button to trigger click.
    //  * @type {string}
    //  */
    // const SUBMIT_BUTTON = '[type="submit"]';

    // /**
    //  * Sort dropdown selector, we add listener, to listen on changes and trigger submit on change.
    //  * @type {string}
    //  */
    // const SORT_DROPDOWN = '.sq-form-field:nth-child(2)';

    const EVENT_DATEPICKER_HIDDEN_INPUT = '#event-date';

    const EVENT_DATEPICKER_INPUT_CLASS = [
        '.search-form__search-banner__form__select--event-date',
    ];

    const EVENT_DATEPICKER_INPUT_CLASSES = [
        '.search-form__search-banner__form__select--event-date-mobile',
        '.search-form__search-banner__form__select--event-date-desktop',
    ];

    class SearchForm {
        constructor(searchFormWrapper) {
            this.searchFormWrapper = searchFormWrapper;

            EVENT_DATEPICKER_INPUT_CLASSES.forEach((inputClass) => {
                datepicker(inputClass, {
                    customDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                    minDate: new Date(),
                    onSelect: (instance, date) => {
                        // Do stuff when a date is selected (or unselected) on the calendar.
                        // You have access to the datepicker instance for convenience.
                        const formattedDate = date.toLocaleDateString();
                        // below might be needed instead depending on what FB will accept as facet/ filter
                        // const formattedDate = date.toISOString();
                        // update the hidden field used for search form submission
                        const eventHiddenInput = document.querySelector(
                            EVENT_DATEPICKER_HIDDEN_INPUT
                        );
                        if (eventHiddenInput) {
                            eventHiddenInput.value = formattedDate;
                        }
                        // update all datepicker instances with the same value
                        document
                            .querySelectorAll(EVENT_DATEPICKER_INPUT_CLASS)
                            .forEach((dateInput) => {
                                dateInput.value = formattedDate;
                            });
                    },
                });
            });
        }
    }

    const SearchComponents = document.querySelectorAll(SEARCH_FORM_COMPONENT);

    SearchComponents.forEach((item) => {
        // Create a new item to modify
        const DOMItem = item;

        // Attach the class instance to our DOMItem
        if (!DOMItem.searchForm) {
            DOMItem.searchForm = new SearchForm(item);
        }
    });
}

_searchForm();
